import { Box, Skeleton } from "@mui/material";
import { Card, Container, Main, Navbar, NavLeft, NavRight, styles, TabBox, TabsContainer, VerticalDivider } from "./styles";

export const HomePageSkeleton = () => {
    return (
        <Container>
            <Navbar>
                <NavLeft>
                        <Skeleton variant="rectangular" width={130} height={40} />
                        <Box sx={styles.navLeftBox}>
                            <Skeleton variant="text" width={60} />
                            <Skeleton variant="text" width={90} />
                            <Skeleton variant="text" width={80} />
                        </Box>
                </NavLeft>

                <NavRight>
                    <Box sx={styles.navRightBox1}>
                        <Skeleton variant="text" width={150} />
                        <Skeleton variant="circular" width={40} height={40} />
                    </Box>
                    <Box  sx={styles.navRightBox2}>
                        <Skeleton variant="rectangular" width={20} height={2} />
                        <Skeleton variant="rectangular" width={20} height={2} />
                        <Skeleton variant="rectangular" width={20} height={2} />
                    </Box>
                </NavRight>
            </Navbar>

            <Main>
                <Card>
                    <TabsContainer>
                        <TabBox>
                            <Skeleton variant="rectangular" width={45} height={50} />
                            <Skeleton variant="text" width={40} height={10} />
                            <Skeleton variant="text" width={40} height={4} mt={2} />
                        </TabBox>
                        <VerticalDivider orientation="vertical" />
                        <TabBox>
                            <Skeleton variant="rectangular" width={45} height={50} />
                            <Skeleton variant="text" width={40} height={10} />
                            <Skeleton variant="text" width={40} height={4} mt={2} />
                        </TabBox>
                    </TabsContainer>

                    <Skeleton variant="text" width="60%" height={80} sx={{ mt: 3, mb: 1.5 }} />
                    <Skeleton variant="text" width="80%" />
                    <Skeleton variant="text" width="70%" sx={{ mb: 2 }} />
                    <Skeleton variant="rectangular" width={150} height={35} sx={{ borderRadius: '30px' }}/>
                </Card>
                <Box></Box>
            </Main>
        </Container>
    );
}
